/* Entrance Handles purchase options. Rebuilt 15 Sep 2026.

   1. Every group marked [data-eh-required] (Finish, and Screw length once James
      supplies the lengths) must be answered before add to cart.
   2. Express checkout stays hidden until they are. The CSS does this and fails
      closed; the class toggled here is only the second belt.
   3. Optional text fields ([data-eh-name]) only carry a name, and so only submit,
      when they hold a value. A blank field would otherwise put an empty line on
      the order, which is exactly what the hidden custom-colour box did on #1003.
   4. The custom-colour box only submits when the custom-colour variant is chosen.
   5. Fixing centres are shown for the selected size.
   6. Dawn re-renders the buy form on a size change, wiping every answer. Answers
      are remembered per product and put back after each re-render. */
(function () {
  if (window.__ehPurchaseOptions) return;
  window.__ehPurchaseOptions = true;

  var CART_FORM = 'form[action*="/cart/add"]';
  var remembered = {};

  function formKey(form) {
    var pid = form.querySelector('[name="product-id"]');
    return (pid && pid.value) || form.id || 'default';
  }

  /* ---------- custom colour box ---------- */
  function syncPowderColour() {
    var on = !!document.querySelector(
      'input[type=radio][value*="Custom Colour"]:checked, input[type=radio][value*="Custom Color"]:checked'
    );
    document.querySelectorAll('input[id^="PowderCoatColour-"]').forEach(function (input) {
      var box = input.closest('.product-form__input');
      var want = on ? 'block' : 'none';
      if (box && box.style.display !== want) box.style.display = want;
      if (input.disabled === on) input.disabled = !on;
      if (!on && input.value !== '') input.value = '';
    });
  }

  /* ---------- optional text properties ---------- */
  function syncOptionalNames() {
    document.querySelectorAll('input[data-eh-name]').forEach(function (input) {
      var want = input.value.trim() ? input.getAttribute('data-eh-name') : null;
      var have = input.getAttribute('name');
      if (want && have !== want) input.setAttribute('name', want);
      if (!want && have !== null) input.removeAttribute('name');
    });
  }

  /* ---------- fixing centres ---------- */
  function parseCentresMap(script) {
    var map = {};
    (script.textContent || '').split(/[~\n]/).forEach(function (line) {
      var parts = line.trim().split('|');
      if (parts.length === 2 && parts[0]) map[parts[0]] = parts[1];
    });
    return map;
  }

  function syncCentres() {
    document.querySelectorAll('[data-eh-centres]').forEach(function (note) {
      var form = note.closest(CART_FORM);
      var script = (form || document).querySelector('[data-eh-centres-map]');
      var idInput = (form || document).querySelector('input.product-variant-id');
      if (!script || !idInput) return;
      var text = parseCentresMap(script)[idInput.value] || '';
      /* Only write on change: writing textContent is a childList mutation, so an
         unconditional write retriggers the observer below and locks the tab. */
      if (note.textContent !== text) note.textContent = text;
      if (note.hidden !== !text) note.hidden = !text;
    });
  }

  /* ---------- required groups ---------- */
  function groupName(fieldset) {
    return fieldset.getAttribute('data-eh-group') || 'group';
  }

  function missingGroups(form) {
    var out = [];
    form.querySelectorAll('[data-eh-required]').forEach(function (fs) {
      /* 17 Sep: door thickness is a required text field, not a radio group, so a
         container with no radios is judged on its text input instead. Without this
         branch a radio-less required block counted as permanently missing and the
         Add to cart button could never be satisfied. */
      if (fs.querySelector('input[type=radio]')) {
        if (!fs.querySelector('input[type=radio]:checked')) out.push(fs);
        return;
      }
      var txt = fs.querySelector('input[data-eh-name], input[type=text]');
      if (txt && !String(txt.value || '').trim()) out.push(fs);
    });
    return out;
  }

  function restoreAnswers() {
    document.querySelectorAll(CART_FORM).forEach(function (form) {
      var key = formKey(form);
      form.querySelectorAll('[data-eh-required]').forEach(function (fs) {
        if (fs.querySelector('input[type=radio]:checked')) return;
        var want = remembered[key + '|' + groupName(fs)];
        if (!want) return;
        /* Goes inside a quoted attribute selector, so only a backslash and a double
           quote need escaping. CSS.escape is for identifiers and would escape the
           spaces in "Matt clear powder coat", which then matches nothing. */
        var safe = String(want).replace(/["\\]/g, '\\$&');
        var match = fs.querySelector('input[type=radio][value="' + safe + '"]');
        if (match) match.checked = true;
      });
      form.querySelectorAll('input[data-eh-name]').forEach(function (input) {
        if (input.value) return;
        var want = remembered[key + '|' + input.getAttribute('data-eh-name')];
        if (want) input.value = want;
      });
    });
  }

  function showError(fieldset) {
    fieldset.classList.add('eh-finish--invalid');
    var error = fieldset.querySelector('[data-eh-error]');
    if (error) {
      error.hidden = false;
      error.setAttribute('role', 'alert');
    }
    try {
      fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      fieldset.scrollIntoView();
    }
    var first = fieldset.querySelector('input[type=radio], input[data-eh-name], input[type=text]');
    if (first) first.focus({ preventScroll: true });
  }

  function clearError(fieldset) {
    fieldset.classList.remove('eh-finish--invalid');
    var error = fieldset.querySelector('[data-eh-error]');
    if (error) error.hidden = true;
  }

  function syncButtons() {
    document.querySelectorAll(CART_FORM).forEach(function (form) {
      if (!form.querySelector('[data-eh-required]')) return;
      var locked = missingGroups(form).length > 0;
      /* design swarm U26, 30 Sep 2026: the hint follows the same lock as the buttons */
      var hint = form.querySelector('[data-eh-express-hint]');
      if (hint) hint.hidden = !locked;
      var express = form.querySelector('.shopify-payment-button');
      if (express) {
        express.classList.toggle('eh-locked', locked);
        var aria = locked ? 'true' : 'false';
        if (express.getAttribute('aria-hidden') !== aria) express.setAttribute('aria-hidden', aria);
      }
    });
  }

  /* Capture phase on document, so this runs before Dawn's own submit handler on
     the form, which would otherwise already have sent its fetch to /cart/add. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches(CART_FORM)) return;
      syncOptionalNames();
      var missing = missingGroups(form);
      if (missing.length) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        missing.forEach(function (fs) { fs.classList.add('eh-finish--invalid'); });
        showError(missing[0]);
      }
    },
    true
  );

  document.addEventListener('input', function (event) {
    var t = event.target;
    if (!t || !t.matches || !t.matches('input[data-eh-name]')) return;
    var fs = t.closest('[data-eh-required]');
    if (fs && String(t.value || '').trim()) clearError(fs);
    syncButtons();
  });

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (t && t.type === 'radio') {
      var fs = t.closest('[data-eh-required]');
      var form = t.closest(CART_FORM);
      if (fs && form) {
        remembered[formKey(form) + '|' + groupName(fs)] = t.value;
        clearError(fs);
      }
    }
    syncAll();
  });

  document.addEventListener('input', function (event) {
    var t = event.target;
    if (t && t.matches && t.matches('input[data-eh-name]')) {
      var form = t.closest(CART_FORM);
      if (form) remembered[formKey(form) + '|' + t.getAttribute('data-eh-name')] = t.value;
      syncOptionalNames();
    }
  });

  var syncing = false;
  var queued = false;

  function syncAll() {
    if (syncing) return;
    syncing = true;
    try {
      restoreAnswers();
      syncOptionalNames();
      syncPowderColour();
      syncCentres();
      syncButtons();
    } finally {
      syncing = false;
    }
  }

  /* setTimeout, not requestAnimationFrame: rAF never fires in a background tab,
     which would leave `queued` stuck true and stall every later sync. */
  function scheduleSync() {
    if (queued) return;
    queued = true;
    window.setTimeout(function () {
      queued = false;
      syncAll();
    }, 16);
  }

  /* The script can load before the body exists, where observe() would throw. */
  function start() {
    syncAll();
    try {
      new MutationObserver(scheduleSync).observe(document.body, { subtree: true, childList: true });
    } catch (e) {
      /* change/input listeners and the CSS lock still cover the critical path */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* ------------------------------------------------------------------
   16 mm bar on a long handle. Nick, 17 Sep: warn the customer at the point of
   choosing rather than letting a slim bar go onto a heavy entrance door.
   Only the Straight D-Pull in brass and bronze offers 16 mm, and the dialog is
   only rendered on products that do, so this is inert everywhere else.
   ------------------------------------------------------------------ */
(function () {
  if (window.__ehSlimInit) return;
  window.__ehSlimInit = true;
  var WARN_AT = 800;
  var shown = {};

  function chosen(scope, label) {
    var sets = scope.querySelectorAll('fieldset, .product-form__input');
    for (var i = 0; i < sets.length; i++) {
      var leg = sets[i].querySelector('legend, .form__label');
      if (!leg || leg.textContent.toLowerCase().indexOf(label) === -1) continue;
      var r = sets[i].querySelector('input[type=radio]:checked');
      if (r) return r.value;
      var s = sets[i].querySelector('select');
      if (s) return s.value;
    }
    return '';
  }

  function mm(v) {
    var m = String(v || '').match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function check() {
    document.querySelectorAll('[data-eh-slim]').forEach(function (box) {
      var scope = box.closest('.product, .product__info-container, main') || document;
      var bar = mm(chosen(scope, 'bar diameter'));
      var len = mm(chosen(scope, 'size'));
      if (bar !== 16 || len < WARN_AT) return;
      var key = bar + 'x' + len;
      if (shown[key]) return;
      shown[key] = true;
      box.hidden = false;
      // carry the length the customer actually picked through to the contact form
      var cta = box.querySelector('[data-eh-slim-cta]');
      if (cta) {
        var base = cta.getAttribute('href').split('&size=')[0];
        cta.setAttribute('href', base + '&size=' + encodeURIComponent(len + ' mm'));
      }
      var btn = box.querySelector('[data-eh-slim-close]');
      if (btn) btn.focus({ preventScroll: true });
    });
  }

  function close(box) { box.hidden = true; }

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.type !== 'radio') return;
    setTimeout(check, 60);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-eh-slim-close]');
    if (b) { close(b.closest('[data-eh-slim]')); return; }
    var box = e.target.closest && e.target.closest('[data-eh-slim]');
    if (box && e.target === box) close(box);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-eh-slim]:not([hidden])').forEach(close);
  });
  setTimeout(check, 400);
})();
